
export default class Parallax {
	constructor(element) {
		this.element = element;
		this.range = parseFloat(this.element.getAttribute("data-parallax-range")) || 100.0;

		this.layers = [];
		for (let layer of this.element.querySelectorAll(".parallax-layer")) {
			this.layers.push({
				element: layer,
				depth: parseFloat(layer.getAttribute("data-parallax-depth")) || 1.0
			});
		}

		this.observer = new IntersectionObserver(this.onObserve.bind(this), {
			rootMargin: "0px",
		});
		this.observer.observe(element);

		this.scrollListener = null;
		this.animationFrame = null;
	}

	bindEvents() {
		if (!this.scrollListener) {
			this.scrollListener = this.onScroll.bind(this);
			window.addEventListener("scroll", this.scrollListener, { passive: true });
		}
	}

	unbindEvents() {
		if (this.scrollListener) {
			window.removeEventListener("scroll", this.scrollListener, { passive: true });
			this.scrollListener = null;
		}
	}

	onObserve(entries) {
		this.isVisible = entries[0].isIntersecting;
		if (this.isVisible) {
			this.bindEvents();
			this.scheduleAnimation();
		}
		else {
			this.unbindEvents();
		}
	}

	onScroll() {
		this.scheduleAnimation();
	}

	scheduleAnimation() {
		if (this.isVisible && !this.animationFrame) {
			this.animationFrame = requestAnimationFrame(this.animateFrame.bind(this));
		}
	}

	animateFrame() {
		this.animationFrame = null;
		let scrollPosition = this.scrollPosition();
		for (let i = 0; i < this.layers.length; ++i) {
			let layer = this.layers[i];
			let translateY = this.range * scrollPosition * layer.depth;
			layer.element.style.transform = "translateY(" + translateY + "px)";
		}
	}

	//
	// Returns value from -1.0 to 1.0.
	//
	scrollPosition() {
		let rect = this.element.getBoundingClientRect();
		let topBound = -rect.height / 2;
		let bottomBound = window.innerHeight + rect.height / 2;

		let value = (rect.top + rect.height / 2 - topBound) / (bottomBound - topBound) * 2 - 1;
		if (value < -1.0) {
			value = -1.0;
		}
		if (1.0 < value) {
			value = 1.0;
		}
		return value;
	}
}
